import { observer } from "mobx-react";
import moment from "moment";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import horizonConfirmStore from "../../stores/Calendar/horizonConfirmStore";

/**
 * Soft-block dialog shown when scheduling or moving a treatment / event time
 * slot past the planning horizon. Driven by `horizonConfirmStore`. Closing via
 * backdrop/escape counts as cancel (nothing is scheduled beyond the horizon).
 */
const HorizonWarningDialog = observer(() => {
  const { open, context } = horizonConfirmStore;

  const dateLabel = context?.date ? moment(context.date).format("DD.MM.YYYY") : "";
  const horizonLabel = context?.horizonDate
    ? moment(context.horizonDate).format("DD.MM.YYYY")
    : "";

  return (
    <Dialog
      open={open}
      onClose={() => horizonConfirmStore.cancel()}
      PaperProps={{ style: { zIndex: 2100 } }}
    >
      <DialogTitle>Planung über den Horizont hinaus</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Der gewählte Termin{dateLabel ? ` am ${dateLabel}` : ""} liegt außerhalb des
          Planungshorizonts{horizonLabel ? ` (${horizonLabel})` : ""}. Möchten Sie trotzdem
          fortfahren?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => horizonConfirmStore.cancel()}>Abbrechen</Button>
        <Button variant="contained" color="warning" onClick={() => horizonConfirmStore.confirm()}>
          Trotzdem planen
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default HorizonWarningDialog;
